// extracted by mini-css-extract-plugin
export var barContainer = "_2x-0";
export var extraThin = "_2x-3";
export var fillBar = "_2x-6";
export var fillContainer = "_2x-4";
export var overflow = "_2x-8";
export var overflowContainer = "_2x-5";
export var regular = "_2x-7";
export var thick = "_2x-1";
export var thin = "_2x-2";